export function extractDistinctProperties<T extends Object>(
  obj1: T,
  obj2: T,
  eqFn: (a: any, b: any) => boolean = (a, b) => a === b
): T {
  return Object.entries(obj1).reduce((acc, [key, value]) => {
    if (!eqFn(obj2[key as keyof T], value)) {
      acc[key as keyof T] = value
    }
    return acc
  }, {} as T)
}
